import { render, staticRenderFns } from "./ProveedorForm.vue?vue&type=template&id=2b12d216&"
import script from "./ProveedorForm.vue?vue&type=script&lang=ts&"
export * from "./ProveedorForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b12d216', component.options)
    } else {
      api.reload('2b12d216', component.options)
    }
    module.hot.accept("./ProveedorForm.vue?vue&type=template&id=2b12d216&", function () {
      api.rerender('2b12d216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Proveedor/ProveedorForm.vue"
export default component.exports